<template>
  <div class="mt-5 text-center w-full"
    :class="$route.params.slug ? 'w-11/12 lg:w-5/6 mx-auto': ''">
    <div class="my-3 py-3 pl-2 text-xl lg:text-2xl tracking-wider w-full">
      <h1 class="w-full mx-auto uppercase text-left">
        Masterclasses
      </h1>
    </div>
    <div v-if="masterclasses.length>0">
      <masterclass-card
        class="w-3/4 mb-8 hidden md:block"
        v-for="masterclass in masterclasses"
        :key="masterclass.id"
        :masterclass="masterclass" />
      <masterclass-card-mobile
        class="w-full mb-8 block md:hidden"
        v-for="masterclass in masterclasses"
        :key="'m_mobile_'+masterclass.id"
        :masterclass="masterclass" />
    </div>
    <div v-else class="flex ml-3 text-base">
      {{$t('masterclass.noMasterclasses')}}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getTeacherMasterclasses } from '@/services/TeacherService';
import MasterclassCard from '../masterclasses/MasterclassCard.vue';
import MasterclassCardMobile from '../masterclasses/MasterclassCardMobile.vue';

export default {
  components: { MasterclassCard, MasterclassCardMobile },

  data() {
    return {
      masterclasses: [],
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },

  created() {
    this.getMasterclasses();
  },

  methods: {
    getMasterclasses() {
      getTeacherMasterclasses(this.$route.params.slug ? this.$route.params.slug : this.user.slug)
        .then(({ data }) => {
          this.masterclasses = data;
        });
    },
  },
};
</script>
